<sm-spinner [loading]="loading$"></sm-spinner>

<ng-container *ngIf="(loading$ | async) === false">
  <ng-container *ngIf="acOptions.length === 0; else hasAcOptions">
    <sm-informative-status [informativeStatus]="warning"> </sm-informative-status>
  </ng-container>
</ng-container>

<ng-template #hasAcOptions>
  <div class="my-5">
    <!-- page-header -->
    <sm-page-header [breadcrumb]="breadcrumb" title="ppm.variants.new"> </sm-page-header>

    <div class="flex flex-row gap-5">
      <!-- Form -->
      <div class="content w-3/4">
        <sm-form-builder [formObject]="formObject"></sm-form-builder>
      </div>
      <!-- Meta Blocks -->
      <div class="flex flex-col gap-2 w-1/4">
        <sm-status status="Nouveau"></sm-status>
        <div class="content h-fit" *ngIf="(controlBlocks | objectPropertyLength) > 0">
          <sm-block-builder [blocks]="controlBlocks"></sm-block-builder>
        </div>
      </div>
    </div>
  </div>
</ng-template>
